export default function () {
    return (
        <div>
            <h1>NoFoundPage</h1>
        </div>
    )
}
